var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weatherWeibo"},[_c('iframe',{staticClass:"iframeWeibo",attrs:{"src":"https://m.weibo.cn/u/2294193132","frameborder":"0"}})])}]

export { render, staticRenderFns }